export const sortJsonObj = (jsonobj: any) => {
  if (!Array.isArray(jsonobj)) {
    console.error("Invalid response format:", jsonobj);
    return [];
  }

  return jsonobj
    .map(segment => ({
      ...segment,
      subSegments: Array.isArray(segment.subSegments)
        ? [...segment.subSegments] // Clone before sorting
            .filter((subSegment: any) => subSegment.name !== "Applications")
            .sort((a: any, b: any) => a.subSegmentOrder - b.subSegmentOrder)
            .map((subSegment: any) => ({
              ...subSegment,
              attributes: Array.isArray(subSegment.attributes)
                ? [...subSegment.attributes].sort(
                    (a: any, b: any) => a.attributeOrder - b.attributeOrder
                  )
                : [],
            }))
        : [],
    }))
    .sort((a, b) => a.segmentOrder - b.segmentOrder);
};

export const removeFaceAttributeFormpayloadJson = (jsonobj: any) => {
  return {
    ...jsonobj,
    formSegments: jsonobj?.formSegments?.map((segment: any) => ({
      ...segment,
      subSegments: segment?.subSegments?.map((subSegment: any) => ({
        ...subSegment,
        attributes: subSegment?.attributes
          .filter((attribute: any) => attribute?.name !== "face")
          .map((attribute: any) => {
            // Modify primaryPhoneNumber value by removing +91 or any leading '+'
            if (attribute?.name === "primaryPhoneNumber" && typeof attribute?.value === "string") {
              return {
                ...attribute,
                value: attribute.value.replace(/^\+91/, '') // Remove only +91
                // OR use: .replace(/^\+/, '') to remove any leading +
              };
            }
            return attribute;
          })
          .sort((a: any, b: any) => a.attributeOrder - b.attributeOrder),
      })),
    })),
  };
};

